/******************************************************************************
 * Copyright (c) 2016 - 2021.                                                 *
 * Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti (Yega Yazilim)          *
 * All Rights Reserved.                                                       *
 *                                                                            *
 * The software and data contained herein are confidential and proprietary    *
 * information of Yega Yazilim ("Confidential Information").                  *
 *                                                                            *
 * Users of this software may not disclose such Confidential Information and  *
 * shall use it only in accordance with the terms of the license agreement    *
 * they entered into with Yega Yazilim.                                       *
 *                                                                            *
 * Author:  Ahmet Dogramaci                                                   *
 * Date:    2021-11-26                                                        *
 ******************************************************************************/

export default {
    props:{
        queryInterfaceObjectKey:{
            type: String,
            default: 'attribute_query_hash'
        }
    },
    provide(){
        return{
            queryChanged:this.queryChanged
        };
    },
    data(){
        return {
            query:{},
        };
    },
    methods:{
        queryChanged(query){
            this.query = query;
            let that = this;
            this.$nextTick(()=>{
                that.loadItems();
            });
        },
        loadItems(){
            this.items_data_source.loadItems(this.query);
        }
    }
}
